import React from 'react';

import { Col, Row } from 'antd';
import Link from 'src/components/Link';
import { IMenu } from 'src/shared/models';

const FooterCols = (
  menuConfig: IMenu[],
  isBottomFooter?: boolean,
  authenticated?: boolean
) => {
  const menuFooterCol1 = menuConfig?.filter(
    (_menuItem) => _menuItem?.order === 1
  )[0];

  const menuFooterCol2 = menuConfig?.filter(
    (_menuItem) => _menuItem?.order === 2
  )[0];

  const menuFooterCol3 = menuConfig?.filter(
    (_menuItem) => _menuItem?.order === 3
  )[0];

  const renderMenu = (menu: IMenu, keyBase: string) => {
    return menu?.subMenu?.map(
      ({ idMenu, disabled, absolute, href, hrefAs, name }) => {
        return absolute ? (
          <a
            key={`${keyBase}-${idMenu}`}
            href={hrefAs}
            target="_blank"
            className={`menu-item link underline-text ${
              disabled ? 'disabled' : ''
            }`}
            rel="noreferrer"
          >
            {name}
          </a>
        ) : (
          <Link key={`${keyBase}-${idMenu}`} as={hrefAs} href={href}>
            <Row className={`menu-item ${disabled ? 'disabled' : ''}`}>
              {name}
            </Row>
          </Link>
        );
      }
    );
  };

  if (isBottomFooter) {
    return (
      <>
        {menuConfig?.map((menuItem, index) => (
          <Col
            key={index}
            xs={24}
            md={authenticated ? 24 : 12}
            className="footer-menu-container"
          >
            <Row gutter={[24, 0]} className="bottom-footer-row">
              {menuItem?.subMenu?.map((child) => (
                <Link key={child.idMenu} as={child.hrefAs} href={child.href}>
                  <Col
                    className={`footer-link ${
                      child.disabled ? 'disabled' : ''
                    }`}
                  >
                    {child.name}
                  </Col>
                </Link>
              ))}
            </Row>
          </Col>
        ))}
      </>
    );
  }

  return (
    <>
      <Col
        xs={authenticated ? 10 : 12}
        lg={authenticated ? 8 : 12}
        key={'menu-footer-col-1'}
        className={`footer-menu-container ${
          !menuFooterCol1 && authenticated ? 'not_show_on_breakpoint-md' : ''
        }`}
      >
        {menuFooterCol1?.name && (
          <Row className="menu-title">{menuFooterCol1.name}</Row>
        )}
        {renderMenu(menuFooterCol1, 'col1')}
      </Col>
      <Col
        xs={authenticated ? 10 : 12}
        lg={authenticated ? 8 : 12}
        key={'menu-footer-col-3'}
        className="footer-menu-container"
      >
        <Row justify="space-between" style={{ height: '100%' }}>
          <Col
            xs={authenticated ? 24 : 16}
            className={`${
              menuFooterCol1 && authenticated
                ? 'show_on_breakpoint-md'
                : 'no-display'
            }`}
          >
            {menuFooterCol3 && (
              <Row className="menu-title">{menuFooterCol3.name}</Row>
            )}
            {renderMenu(menuFooterCol3, 'col3')}
          </Col>
          <Col
            xs={24}
            md={24}
            key={'menu-footer-col-2'}
            className={`footer-menu-container`}
          >
            {menuFooterCol2?.name && (
              <Row className="menu-title">{menuFooterCol2.name}</Row>
            )}
            {renderMenu(menuFooterCol2, 'col2')}
          </Col>
        </Row>
      </Col>
      <Col
        xs={menuFooterCol1 ? 24 : 12}
        md={menuFooterCol1 ? 24 : 12}
        key={'menu-footer-col-3-2'}
        lg={authenticated ? 8 : 12}
        className={`footer-menu-container ${
          menuFooterCol1 ? 'not_show_on_breakpoint-md' : ''
        }`}
      >
        {menuFooterCol3 && (
          <Row className="menu-title">{menuFooterCol3.name}</Row>
        )}
        {renderMenu(menuFooterCol3, 'col3')}
      </Col>
    </>
  );
};

export default FooterCols;
